import { useCallback, useState } from 'react';
import { flushSync } from 'react-dom';
import { useAppwideDrawerContext } from '../../../providers/AppwideDrawerProvider';
import { Button, ButtonVariants } from '../../Button';
import { Divider } from '../../Divider';
import { DrawerFooterFlex } from '../../Drawer/styles';

export const EntityAdminDrawerFooter = ({
  handleOnSave,
  someError,
  runValidation,
}: {
  handleOnSave: () => Promise<void>;
  someError: boolean;
  runValidation: () => void;
}) => {
  const { closeDrawer } = useAppwideDrawerContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleCancel = useCallback(() => {
    closeDrawer();
  }, [closeDrawer]);

  const handleSave = useCallback(async () => {
    if (isLoading) {
      return;
    }

    flushSync(() => setIsLoading(true));
    try {
      await handleOnSave();
    } catch (error) {
      // Error handled upstream; catch prevents unhandled promise rejection
    } finally {
      setIsLoading(false);
    }
  }, [handleOnSave, isLoading]);

  return (
    <DrawerFooterFlex w="100%" gap="12px" p="12px">
      <Button
        style={{ padding: '8px 12px' }}
        flex="none"
        onClick={handleCancel}
        data-testid="entity-admin-drawer-cancel-button"
      >
        Cancel
      </Button>
      <Divider flex="none" orientation="vertical" my="0" />
      <Button
        flex="1"
        onClick={handleSave}
        variant={ButtonVariants.Primary}
        data-testid="entity-admin-drawer-save-button"
        disabled={someError}
        loading={isLoading}
        onMouseOver={runValidation}
      >
        Save
      </Button>
    </DrawerFooterFlex>
  );
};
